import { RESET_PASSWORD_EMAIL_REQUEST, RESET_PASSWORD_EMAIL_SUCCESS, RESET_PASSWORD_EMAIL_ERROR } from '../constants/ActionTypes';
import { Person, ResponseError } from '@ynap/api-utils';
import { timeout, delay } from '@ynap/promise-utils';

function resetPasswordEmailRequest() {
    return {
        type: RESET_PASSWORD_EMAIL_REQUEST,
    };
}
function resetPasswordEmailSuccess() {
    return {
        type: RESET_PASSWORD_EMAIL_SUCCESS,
    };
}
function resetPasswordEmailError(error) {
    return {
        type: RESET_PASSWORD_EMAIL_ERROR,
        error,
    };
}

export default function resetPasswordEmail(credentials, form = 'resetPassword', requestDelay) {
    return (dispatch, getState, fetch) => {
        const {
            config,
            appState: {
                locale: { country, locale: langISO },
            },
        } = getState();
        const { clientRequest } = config.head || config;
        const { baseUrl, clientId, clientSecret } = config.watsonService || config.global.services.commerce;
        const { brandId } = config.watsonService || config.global.application;

        const user = { ...credentials, resetPassword: 'true' };
        const request = Person.userUpdate({ baseUrl, brandId, country, user, clientId, clientSecret, options: { locale: langISO } });

        dispatch(resetPasswordEmailRequest());

        return delay(timeout(fetch(request), clientRequest.timeout), requestDelay || clientRequest.delay)
            .then((response) => {
                if (response.ok) {
                    return dispatch(resetPasswordEmailSuccess());
                }
                throw new ResponseError(response);
            })
            .catch((error) => {
                dispatch(resetPasswordEmailError(error));
                throw error;
            });
    };
}
